export default "__VITE_ASSET__C5LKvuiI__"